import React, { useEffect } from 'react';
import { useCore } from 'contexts/core';
import { useDispatch, useSelector } from 'react-redux';
import { darkScene, isDoorsVisible, isSceneDark, lightScene } from 'ducks/layout';
import { NightLightsSystem } from '@inter-ikea-storageone/range';

const NightLightsWidget = () => {
  const sceneIsDark = useSelector(isSceneDark);
  const doorsVisible = useSelector(isDoorsVisible);
  const coreApi = useCore();
  const dispatch = useDispatch();

  useEffect(() => {
    if (sceneIsDark) {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enable();
    } else {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sceneIsDark]);

  useEffect(() => {
    if (sceneIsDark) {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disable();
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doorsVisible]);

  useEffect(() => {
    const onEnableNightMode = (enabled: boolean) => {
      if (enabled) {
        dispatch(darkScene());
      } else {
        dispatch(lightScene());
      }
    };

    return coreApi.subscribe('enableNightMode', onEnableNightMode);
  }, [coreApi, dispatch]);

  return <></>;
};

export default NightLightsWidget;
